import React from "react";
import Img from "./Img";

export default function InfoMessage(props) {
    return (
        <div className="c_40">
            <Img className="c_40_1" src="icon_caution.svg" height="64px" width="64px" />
            <div className="c_40_2">{props.text}</div>
        </div>
    )
}
